export default __webpack_public_path__ + "static/media/background-artwork.bac39e03.png";